import { createApiClient } from "./apiClient";

export class SolutionTrainService {
  constructor(authAPIUrl) {
    this.apiClient = createApiClient(authAPIUrl, "v1/solution-train");
  }

  async getSolutionTrains() {
    return this.apiClient.get();
  }

  async getSolutionTrain(id) {
    return this.apiClient.get(id);
  }

  async getMembers(id) {
    return this.apiClient.get(`${id}/members`);
  }

  async createSolutionTrain(name, arts, userIds) {
    return this.apiClient.post("", { name, art_ids: arts, user_ids: userIds });
  }

  async updateSolutionTrain(id, name, arts, userIds) {
    return this.apiClient.patch(id, { name, art_ids: arts, user_ids: userIds });
  }

  async deleteSolutionTrain(id) {
    return this.apiClient.delete(id);
  }
}
